import { createSelector } from "@ngrx/store";
import * as fromFeature from "../reducers";
import * as fromActiveEditions from "../reducers/student-active-editions.reducer";

export const getActiveEditionsState = createSelector(
    fromFeature.getStudentCoursesModuleState,
    (state: fromFeature.StudentCoursesState) => state.activeEditions
);

export const getActiveEditionsEntities = createSelector(
    getActiveEditionsState,
    fromActiveEditions.getActiveEditionsEntities
);

export const getAllActiveEditions = createSelector(
    getActiveEditionsEntities,
    (entities) => {
        return Array.from(entities.values());
    }
);

export const getActiveEditionsLoading = createSelector(
    getActiveEditionsState,
    fromActiveEditions.getActiveEditionsLoading
);

export const getActiveEditionsLoaded = createSelector(
    getActiveEditionsState,
    fromActiveEditions.getActiveEditionsLoaded
);
